// removed by extract-text-webpack-plugin
module.exports = {"starList":"_3bk6z5PX7yuz4MJCz_wHm5"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/WelcomeContent/style.css
 ** module id = 591
 ** module chunks = 0
 **/